import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useGame } from "../context/GameContext";
import { ACHIEVEMENTS } from "../lib/content";
import TopBar from "../components/TopBar";
import { speak } from "../lib/speech";
import { Coins, Star, Gem, Flame } from "lucide-react";

const Big = ({ icon: Icon, value, label, color }) => (
  <div className="flex flex-1 flex-col items-center rounded-3xl bg-white p-4 shadow-lg">
    <Icon className="h-8 w-8" style={{ color }} />
    <span className="font-display text-2xl font-bold text-slate-800">{value}</span>
    <span className="text-xs font-bold text-slate-400">{label}</span>
  </div>
);

export default function Rewards() {
  const { profile } = useGame();
  useEffect(() => { const t = setTimeout(() => speak("Kijk eens naar al jouw beloningen!"), 400); return () => clearTimeout(t); }, []);
  if (!profile) return null;
  const earned = new Set(profile.achievements || []);
  const keys = Object.keys(ACHIEVEMENTS);

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-100 via-sky-50 to-emerald-50">
      <TopBar title="Beloningen" />
      <div className="mx-auto max-w-2xl px-4 pb-16 pt-4">
        <div className="flex gap-3">
          <Big icon={Coins} value={profile.coins} label="Munten" color="#EAB308" />
          <Big icon={Star} value={profile.stars} label="Sterren" color="#FB923C" />
          <Big icon={Gem} value={profile.diamonds} label="Diamanten" color="#38BDF8" />
          <Big icon={Flame} value={profile.streak_count} label="Reeks" color="#EF4444" />
        </div>

        <h2 className="mb-3 mt-6 font-display text-2xl font-bold text-slate-800">Jouw badges</h2>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {keys.map((k, i) => {
            const a = ACHIEVEMENTS[k];
            const has = earned.has(k);
            return (
              <motion.button
                key={k} data-testid={`badge-${k}`}
                initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: i * 0.05, type: "spring" }}
                onClick={() => speak(has ? `${a.title}. ${a.desc}` : `Nog op slot. ${a.desc}`)}
                className={`flex flex-col items-center gap-1 rounded-3xl p-4 shadow-lg ${has ? "bg-white" : "bg-slate-100 opacity-60"}`}
              >
                <span className={`text-4xl ${has ? "" : "grayscale"}`}>{a.icon}</span>
                <span className="font-display text-sm font-bold text-slate-700">{a.title}</span>
                <span className="text-center text-[11px] font-bold text-slate-400">{a.desc}</span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
